import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import FingoRadio from '../../../radios/FingoRadio';
import FingoCheckedRadio from '../../../radios/FingoCheckedRadio';
import useIsMobile from '../../../../hooks/useIsMobile';
import CessionTypeOption from '../../../options/CessionTypeOption';
import ShoppingCartStepperNavigation from '../../ShoppingCartStepperNavigation';
import useCessionTypeOptions from '../../../../hooks/useCessionTypeOptions';
import ShoppingCartSummaryActionButton from '../../ShoppingCartSummary/ShoppingCartSummaryActionButton';
import DEFAULT_RADIO_CLASS_NAME from '../../../../theme/constants/radio';
import CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME from '../../../../theme/constants/form-control-label';

const CessionTypeSelectorStep = ({
  prevStep,
  nextStep,
  selectedCessionType,
  setSelectedCessionType,
  selectedProvider,
  allDocumentsHaveXML,
}) => {
  const options = useCessionTypeOptions(selectedProvider, allDocumentsHaveXML);
  const isMobile = useIsMobile();
  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="cession-type"
          name="cession-type"
          value={selectedCessionType}
          onChange={(event) => setSelectedCessionType(event.target.value)}
        >
          {options.map(({ value, ...props }) => (
            <FormControlLabel
              key={value}
              value={value}
              control={(
                <Radio
                  color="primary"
                  icon={<FingoRadio />}
                  checkedIcon={<FingoCheckedRadio />}
                  className={DEFAULT_RADIO_CLASS_NAME}
                />
              )}
              labelPlacement="start"
              label={<CessionTypeOption {...props} isMobile={isMobile} />}
              className={CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME}
              sx={{
                marginBottom: 2,
                ml: 0,
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <ShoppingCartStepperNavigation onBack={prevStep}>
        <ShoppingCartSummaryActionButton
          id="confirm-cession-type-selector-button"
          label={(
            <Typography variant="small_3" color="white" fontWeight={600}>
              Continuar
            </Typography>
          )}
          disabled={!selectedCessionType}
          onClick={nextStep}
          size="small"
        />
      </ShoppingCartStepperNavigation>
    </>
  );
};

CessionTypeSelectorStep.propTypes = {
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  selectedCessionType: PropTypes.string.isRequired,
  setSelectedCessionType: PropTypes.func.isRequired,
  selectedProvider: PropTypes.shape({
    id: PropTypes.string,
    iconUrl: PropTypes.string,
    name: PropTypes.string,
    integrated: PropTypes.bool,
  }),
  allDocumentsHaveXML: PropTypes.bool,
};

CessionTypeSelectorStep.defaultProps = {
  selectedProvider: null,
  allDocumentsHaveXML: false,
};

export default CessionTypeSelectorStep;
